export interface UserModel {
  id?: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  emailAddress?: string;
  organization?: string;
  userName?: string;
  uid?: string;
  authSource?: string;
  lastLogin?: Date;
  createdAt?: Date;
  updatedAt?: Date;
  roles?: string;
  isCurrentUser?: boolean;
  privileges?: string[];
  managers?: string[];
  incomingToken?: string;
  outgoingToken?: string;
  incomingAuthenticationMechanism?: string;
  outgoingAuthenticationMechanism?: string;
  webhooks?: any;
}

const webhooksValues = [
  "installation-partner-deployment-changed",
];

function toDate(obj: any) {
  if (obj === "" || obj === null || obj === undefined) return null;
  if (obj instanceof Date) return obj;
  if (typeof obj === "number") return new Date(obj);
  if (typeof obj === "string") return new Date(obj);
  return null;
}

export function userModelFactory(json?: any): UserModel {
  json = json || {};

  const webhooks = {};
  json.webhooks = json.webhooks || {};
  webhooksValues.forEach((wh) => {
    webhooks[wh] = json.webhooks[wh] || "";
  });

  const model = {
    id: json.id || "",
    firstName: json.firstName || "",
    lastName: json.lastName || "",
    emailAddress: json.emailAddress || "",
    organization: json.organization || "",
    userName: json.userName || "",
    uid: json.uid || "",
    authSource: json.authSource || "",
    lastLogin: toDate(json.lastLogin),
    createdAt: toDate(json.createdAt),
    updatedAt: toDate(json.updatedAt),
    roles: json.roles || "",
    isCurrentUser: !!json.isCurrentUser,
    privileges: Array.from(json.privileges || []),
    managers: Array.from(json.managers || []),
    incomingToken: json.incomingToken || "",
    outgoingToken: json.outgoingToken || "",
    incomingAuthenticationMechanism: json.incomingAuthenticationMechanism || "",
    outgoingAuthenticationMechanism: json.outgoingAuthenticationMechanism || "",
    webhooks,
  } as UserModel;

  model.displayName = [model.firstName, model.lastName].filter(it => it).join(" ");

  return model;
}

export function userModelListFactory(json?: any): UserModel[] {
  return Array.from(json || []).map(user => userModelFactory(user));
}
